export const SearchDisabledPrivateGroup = "ORa";
export const archiveMailboxFoldersSearchPlaceholder = "PRa";
export default {SearchDisabledPrivateGroup,archiveMailboxFoldersSearchPlaceholder};